document.addEventListener('DOMContentLoaded', () => {
  const heroes = document.querySelectorAll('.maviva-hero');
  // BUG FIX a11y: Controllo se l'utente preferisce ridurre le animazioni
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  heroes.forEach(hero => {
    // Innesca le animazioni di entrata del testo
    setTimeout(() => {
      hero.classList.add('is-loaded');
    }, 100);

    // Effetto Parallasse dello sfondo
    const bgWrapper = hero.querySelector('.js-parallax-bg');
    
    // Attiviamo l'event listener solo se non c'è restrizione al movimento
    if (bgWrapper && !prefersReducedMotion) {
      window.addEventListener('scroll', () => {
        // BUG FIX: Spostato il check della larghezza dentro l'evento di scroll per gestire correttamente il window resize
        if (window.innerWidth >= 768) {
          const scrollPosition = window.scrollY;
          const heroTop = hero.offsetTop;
          const heroHeight = hero.offsetHeight;
          
          if (scrollPosition >= heroTop - window.innerHeight && scrollPosition <= heroTop + heroHeight) {
            const yPos = (scrollPosition - heroTop) * 0.35;
            requestAnimationFrame(() => {
              bgWrapper.style.transform = `translateY(${yPos}px)`;
            });
          }
        } else {
          // Reset se si rimpicciolisce la finestra a mobile mentre si fa scroll
          requestAnimationFrame(() => {
            bgWrapper.style.transform = 'translateY(0)';
          });
        }
      }, { passive: true });
    }
  });
});